@if (!isTrustLoading() && trustViewModel()) {
  <div class="trust-profile-container">
    <div class="trust-profile-wrapper d-flex gap-24">
      <div class="left d-flex flex-column gap-24">
        <app-trust-profile-card
          [isDocumentsLoading]="isDocumentsLoading()"
          [pendingDocumentsQuantity]="pendingDocuments().length"
          [trustProfile]="trustViewModel()"
          [disableControls]="modalOpened()"
          [showXpm]="isXpmConnected()"
          (onTrustRefreshed)="onTrustRefreshedEvent()"
        />

        <app-entity-profile-tags
          [entityProfile]="trustViewModel()"
          [disableControls]="modalOpened()"
        />

        @if (pendingDocuments().length) {
          <app-entity-pending-changes
            [trustView]="true"
            [isPendingChangesVisible]="isPendingChangesVisible()"
            [pendingDocuments]="pendingDocuments()"
            [disableControls]="modalOpened()"
            (deletePendingDocuments)="deleteDocumentChange($event)"
            (setIsPendingChangesVisible)="setIsPendingChangesVisible($event)"
          />
        }
      </div>

      <div class="right d-flex flex-column flex-grow-1">
        <div id="details" class="card mb-4">

          @if (!isTabsHidden()) {
            <div class="card-header">
              <div class="d-flex align-items-center justify-content-between gap-24">
                <div class="left">
                  <div class="tab-container">
                    @for (tab of tabs(); track $index) {
                      <app-tab-button
                        [isActive]="activeTab() === tab.title"
                        (tabClicked)="setActiveTab(tab)"
                        [isDisabled]="modalOpened()"
                      >
                        {{ tab.title }}
                      </app-tab-button>
                    }
                  </div>

                  <div class="vertical-divider"></div>

                  <div class="notes-alerts-buttons">
                    <app-tab-button
                      iconClass="ic-alert-triangle-20"
                      [isActive]="alertsVisible()"
                      [isDisabled]="!trustViewModel().alerts.length || modalOpened()"
                      (tabClicked)="alertsVisible.set(!!trustAlerts().length)"
                    >
                      {{ alertsLabel() }}
                    </app-tab-button>

                    <app-tab-button
                      *appHasRole="['Admin', 'Manager', 'Preparer']"
                      iconClass="ic-notes-20"
                      [isActive]="notesVisible()"
                      [isDisabled]="modalOpened()"
                      (tabClicked)="notesVisible.set(true)"
                    >
                      {{ notesLabel() }}
                    </app-tab-button>
                  </div>
                </div>

                <div *appHasRole="['Admin', 'Manager', 'Preparer']">
                  @switch (activeTab()) {
                    @case ('Details') {
                      <div
                        ngbDropdown
                        placement="bottom-right"
                        class="dropdown"
                      >
                        <button
                          ngbDropdownToggle
                          id="trust-actions-dd"
                          class="btn btn-primary d-flex align-items-center gap-2"
                          [disabled]="modalOpened()"
                        >
                          <span>Actions</span>
                          <i class="icon ic-select-20"></i>
                        </button>

                        <div
                          ngbDropdownMenu
                          aria-labelledby="trust-actions-dd"
                          class="common-dropdown-menu dropdown-menu dropdown-menu-right"
                        >
                          <button ngbDropdownItem (click)="openEditTrustDetailsModal()">
                            <i class="icon ic-trusts-20"></i>
                            <div class="title">Update trust details</div>
                          </button>

                          <button ngbDropdownItem (click)="openTrustDistributionModal()">
                            <i class="icon ic-form-20"></i>
                            <div class="title">Trust Distribution Resolution or Minutes</div>
                          </button>
                        </div>
                      </div>
                    }
                    @case ('Relationships') {
                      @if (trustViewModel().trustType == TrustType.Discretionary) {
                        <div
                          ngbDropdown
                          class="dropdown"
                          placement="bottom-right"
                        >
                          <button
                            ngbDropdownToggle
                            id="trust-actions-relationships-dd"
                            class="btn btn-primary d-flex align-items-center gap-2"
                            [disabled]="modalOpened()"
                          >
                            <span>Actions</span>
                            <i class="icon ic-select-20"></i>
                          </button>

                          <div
                            ngbDropdownMenu
                            aria-labelledby="trust-actions-relationships-dd"
                            class="common-dropdown-menu dropdown-menu dropdown-menu-right"
                          >
                            <button
                              ngbDropdownItem
                              (click)="changeAppointor()"
                            >
                              <i class="icon ic-form-20"></i>
                              <div class="title">Change of Appointor</div>
                            </button>
                          </div>
                        </div>
                      }
                    }
                    @case ('Trustee') {
                      <div
                        ngbDropdown
                        placement="bottom-right"
                        class="dropdown"
                      >
                        <button
                          ngbDropdownToggle
                          id="trust-actions-trustee-dd"
                          class="btn btn-primary d-flex align-items-center gap-2"
                          [disabled]="modalOpened()"
                        >
                          <span>Actions</span>
                          <i class="icon ic-select-20"></i>
                        </button>

                        <div
                          ngbDropdownMenu
                          aria-labelledby="trust-actions-trustee-dd"
                          class="common-dropdown-menu dropdown-menu dropdown-menu-right"
                        >
                          <button
                            ngbDropdownItem
                            (click)="changeTrustee()"
                          >
                            <i class="icon ic-form-20"></i>
                            <div class="title">Change of Trustee</div>
                          </button>
                        </div>
                      </div>
                    }
                  }
                </div>

              </div>
            </div>
          }

          <div>
            @if (activeTab() === 'Details') {
              <app-trust-details [trustProfile]="trustViewModel()"/>
            } @else if (activeTab() === 'Trustee') {
              <div class="card-body">
                <app-list-grid-client-side
                  [rowData]="trustViewModel().trustees!"
                  [colDefs]="$any(colDefs)"
                  [suppressRowClickSelection]="true"
                  [suppressCellFocus]="true"
                  [paginationPageSizeSelector]="true"
                  (select)="selectItems($event)"
                />
              </div>
            } @else if (activeTab() === 'Beneficiaries') {
              <div class="card-body">
                <app-list-grid-client-side
                  [rowData]="trustViewModel().beneficiaries!"
                  [colDefs]="$any(colDefs)"
                  [suppressRowClickSelection]="true"
                  [suppressCellFocus]="true"
                  [paginationPageSizeSelector]="true"
                  (select)="selectItems($event)"
                />
              </div>
            } @else if (activeTab() === 'UnitHolders') {
              <app-entity-securityholders-view
                [showCompanyActions]="false"
                [isLoading]="isShareholdersLoading()"
                [shareholdersViewModel]="unitholdersBeneficiaryViewModel()"
                (patchShareholdersViewModel)="patchShareholdersViewModel($event)"
              />
            } @else if (activeTab() === 'Relationships') {
              <div class="card-body">
                <div class="mb-4">
                  <label class="d-flex align-items-center gap-2 mb-0">
                    <app-toggle-button
                      [disabled]="isLoading() || modalOpened()"
                      (switchBtn)="setIsPastRelationshipsVisible($event)"
                    />

                    <span class="font-size-14">Show Past Relationships</span>
                  </label>
                </div>

                <app-list-grid-client-side
                  [rowData]="trustRelationships()"
                  [colDefs]="$any(relationshipColDefs)"
                  [suppressRowClickSelection]="true"
                  [suppressCellFocus]="true"
                  [paginationPageSizeSelector]="true"
                  (select)="selectItems($event)"
                />
              </div>
            } @else if (activeTab() === 'Documents') {
              <app-documents-grid
                storageKey="trust-documents"
                [entityId]="trustViewModel().entityId"
              />
            }
          </div>
        </div>
      </div>
    </div>
  </div>

  <app-notes
    [entityId]="trustViewModel().entityId"
    [opened]="notesVisible()"
    (close)="notesVisible.set(false)"
    (notesTotalChanged)="onNotesTotalChanged($event)"
  />

  <app-alerts-list
    [alerts]="trustViewModel().alerts"
    [entityType]="EntityType.Trust"
    [entity]="trustViewModel()"
    [opened]="alertsVisible()"
    (close)="alertsVisible.set(false)"
  />
}

<app-loader [loading]="isTrustLoading()"/>
